export default function ButtonBackPaginationComponent({
   setBackPage,
   disable,
}) {
   return (
      <button
         className={`w-[40px] h-[40px] ${
            disable ? "bg-[#667085] cursor-not-allowed" : "brand-primary"
         } text-white flex justify-center items-center`}
         onClick={setBackPage}
         disabled={disable}
      >
         <img src="/assets/backarrow.png"></img>
      </button>
   );
}
